/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterfaceConfigurationType = exports.Intent = exports.InstallPage = exports.InitDirection = exports.IncompleteSetupReason = exports.ImageShape = exports.IconType = exports.HostContainerId = exports.HorizontalDocking = exports.HookType = exports.HeightMode = exports.FilterSelectionType = exports.FilterOptionsType = exports.FieldType = exports.ExtensionType = exports.ExtendingComponentType = exports.ExposureRuleType = exports.Exposure = exports.ExecutionType = exports.Environment = exports.EmbeddedScriptPlacement = exports.EmbeddedScriptPages = exports.EmbedCategory = exports.ElementType = exports.DefaultTextStyle = exports.Default = exports.CustomElementScriptType = exports.ContactsNotificationDataRecipientFilterType = exports.ContactsNotificationDataInitiatorType = exports.ConnectMethod = exports.ComponentType = exports.CommonsChannelMediaMimeType = exports.CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType = exports.CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType = exports.ChannelConfigurationChannelType = exports.ChannelChannelType = exports.CalendarType = exports.BusinessModel = exports.BundleAppOrigin = exports.BlockType = exports.BarAlignmentSelected = exports.BackOfficeScriptAssetType = exports.BackOfficeHostingPlatforms = exports.AvatarShape = exports.AppRolloutPolicy = exports.AppGroup = exports.ApiType = exports.ApiFilter = exports.AndroidStyle = exports.AlgorithmType = void 0;
exports.UserNotificationDataType = exports.UserNotificationDataRecipientFilterType = exports.UserNotificationDataInitiatorType = exports.UnitType = exports.UninstallActions = exports.TypedDynamicParamType = exports.ThumbnailsSize = exports.ThumbnailType = exports.TextInputDisplayType = exports.TemplateDefaultColor = exports.TaxTypeConfigurationTaxType = exports.TaxSettingsTaxType = exports.TagType = exports.SyncToCalendar = exports.Status = exports.SortOrder = exports.SimpleType = exports.ScriptType = exports.SchemaScope = exports.RestrictedOperation = exports.ReplacementType = exports.RenewalType = exports.RegionType = exports.Region = exports.PrimitiveType = exports.PluginInterface = exports.PlatformType = exports.PlanPeriodUnit = exports.PlanFormPricingOption = exports.PlanFormDefaultSection = exports.PlanDescription = exports.PingSettingsGroupComponentDataState = exports.PaymentCollectionType = exports.PartialPaymentRestriction = exports.Order = exports.OpenConsentIn = exports.OAuthTechnologies = exports.OAuthAppType = exports.NotificationTopicType = exports.NotificationTopicState = exports.NavigationType = exports.MobileApplication = exports.MediaType = exports.MeasurementSystem = exports.MandatoryField = exports.LockableOperation = exports.ListEventFromCalendars = exports.Level = exports.ItemsSelectionProviderConfigTag = exports.IntervalUnit = void 0;
exports.WixCodePublishTaskName = exports.WidgetWidthType = exports.WidgetVertical = exports.WidgetHorizontal = exports.ViewMode = exports.VerticalDocking = exports.VersionStatus = exports.V1ChannelMediaMimeType = exports.V1ChannelAcceptedMessageTypesAcceptedSmsMessageType = exports.V1ChannelAcceptedMessageTypesAcceptedDirectMessageType = void 0;
var AlgorithmType;
(function (AlgorithmType) {
    AlgorithmType["UNSPECIFIED"] = "UNSPECIFIED";
    AlgorithmType["RELATED_ITEMS"] = "RELATED_ITEMS";
    AlgorithmType["GLOBAL"] = "GLOBAL";
})(AlgorithmType = exports.AlgorithmType || (exports.AlgorithmType = {}));
var AndroidStyle;
(function (AndroidStyle) {
    AndroidStyle["UNKNOWN_ANDROID_STYLE"] = "UNKNOWN_ANDROID_STYLE";
    AndroidStyle["BIG_TEXT"] = "BIG_TEXT";
    AndroidStyle["MESSAGING"] = "MESSAGING";
    AndroidStyle["INBOX"] = "INBOX";
})(AndroidStyle = exports.AndroidStyle || (exports.AndroidStyle = {}));
var ApiFilter;
(function (ApiFilter) {
    ApiFilter["NONE_FILTER"] = "NONE_FILTER";
    ApiFilter["GEO_FILTER"] = "GEO_FILTER";
})(ApiFilter = exports.ApiFilter || (exports.ApiFilter = {}));
var ApiType;
(function (ApiType) {
    ApiType["NONE_TYPE"] = "NONE_TYPE";
    ApiType["APP"] = "APP";
    ApiType["TEMPLATE"] = "TEMPLATE";
    ApiType["PRIVATE_APP"] = "PRIVATE_APP";
    ApiType["WIX_OFFERING"] = "WIX_OFFERING";
    ApiType["VELO_APP"] = "VELO_APP";
    ApiType["API_KEY"] = "API_KEY";
})(ApiType = exports.ApiType || (exports.ApiType = {}));
var AppGroup;
(function (AppGroup) {
    AppGroup["EMPTY"] = "EMPTY";
    AppGroup["INSTALLED"] = "INSTALLED";
    AppGroup["PENDING"] = "PENDING";
    AppGroup["BUSINESS_SOLUTIONS"] = "BUSINESS_SOLUTIONS";
    AppGroup["BUNDLE"] = "BUNDLE";
})(AppGroup = exports.AppGroup || (exports.AppGroup = {}));
var AppRolloutPolicy;
(function (AppRolloutPolicy) {
    AppRolloutPolicy["PETRI_ROLLOUT_POLICY"] = "PETRI_ROLLOUT_POLICY";
    AppRolloutPolicy["INSTALLED_VERSION_ROLLOUT_POLICY"] = "INSTALLED_VERSION_ROLLOUT_POLICY";
})(AppRolloutPolicy = exports.AppRolloutPolicy || (exports.AppRolloutPolicy = {}));
var AvatarShape;
(function (AvatarShape) {
    AvatarShape["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
    AvatarShape["CIRCLE"] = "CIRCLE";
    AvatarShape["SQUARE"] = "SQUARE";
})(AvatarShape = exports.AvatarShape || (exports.AvatarShape = {}));
var BackOfficeHostingPlatforms;
(function (BackOfficeHostingPlatforms) {
    BackOfficeHostingPlatforms["NO_HOSTING_PLATFORM"] = "NO_HOSTING_PLATFORM";
    BackOfficeHostingPlatforms["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    BackOfficeHostingPlatforms["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    BackOfficeHostingPlatforms["DEV_CENTER"] = "DEV_CENTER";
    BackOfficeHostingPlatforms["ENTERPRISE"] = "ENTERPRISE";
    BackOfficeHostingPlatforms["PARTNERS_DASHBOARD"] = "PARTNERS_DASHBOARD";
    BackOfficeHostingPlatforms["FINANCIALS_INTERNAL_BO"] = "FINANCIALS_INTERNAL_BO";
    BackOfficeHostingPlatforms["FED_GUILD_POC"] = "FED_GUILD_POC";
    BackOfficeHostingPlatforms["STUDIO_DASHBOARD"] = "STUDIO_DASHBOARD";
    BackOfficeHostingPlatforms["CHANNELS"] = "CHANNELS";
    BackOfficeHostingPlatforms["DATA_TOOLS"] = "DATA_TOOLS";
    BackOfficeHostingPlatforms["PSP_BACKOFFICE"] = "PSP_BACKOFFICE";
    BackOfficeHostingPlatforms["RISE_PLATFORM_ACCOUNT_DASHBOARD"] = "RISE_PLATFORM_ACCOUNT_DASHBOARD";
    BackOfficeHostingPlatforms["DEMO_DASHBOARD_ENTERPRISE"] = "DEMO_DASHBOARD_ENTERPRISE";
    BackOfficeHostingPlatforms["AI_SCHEDULING_ASSISTANT_DASHBOARD"] = "AI_SCHEDULING_ASSISTANT_DASHBOARD";
})(BackOfficeHostingPlatforms = exports.BackOfficeHostingPlatforms || (exports.BackOfficeHostingPlatforms = {}));
var BackOfficeScriptAssetType;
(function (BackOfficeScriptAssetType) {
    BackOfficeScriptAssetType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    BackOfficeScriptAssetType["MODULE"] = "MODULE";
})(BackOfficeScriptAssetType = exports.BackOfficeScriptAssetType || (exports.BackOfficeScriptAssetType = {}));
var BarAlignmentSelected;
(function (BarAlignmentSelected) {
    BarAlignmentSelected["ALIGN_LEFT"] = "ALIGN_LEFT";
    BarAlignmentSelected["ALIGN_CENTER"] = "ALIGN_CENTER";
    BarAlignmentSelected["ALIGN_RIGHT"] = "ALIGN_RIGHT";
})(BarAlignmentSelected = exports.BarAlignmentSelected || (exports.BarAlignmentSelected = {}));
var BlockType;
(function (BlockType) {
    BlockType["UNKNOWN"] = "UNKNOWN";
    BlockType["OR"] = "OR";
    BlockType["AND"] = "AND";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
var BundleAppOrigin;
(function (BundleAppOrigin) {
    BundleAppOrigin["UNKNOWN"] = "UNKNOWN";
    BundleAppOrigin["VOUCHER"] = "VOUCHER";
    BundleAppOrigin["SILENT_PROVISION"] = "SILENT_PROVISION";
    BundleAppOrigin["COUPON"] = "COUPON";
})(BundleAppOrigin = exports.BundleAppOrigin || (exports.BundleAppOrigin = {}));
var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
    BusinessModel["DYNAMIC"] = "DYNAMIC";
})(BusinessModel = exports.BusinessModel || (exports.BusinessModel = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType = exports.CalendarType || (exports.CalendarType = {}));
var ChannelChannelType;
(function (ChannelChannelType) {
    ChannelChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelChannelType["EMAIL"] = "EMAIL";
    ChannelChannelType["SMS"] = "SMS";
})(ChannelChannelType = exports.ChannelChannelType || (exports.ChannelChannelType = {}));
var ChannelConfigurationChannelType;
(function (ChannelConfigurationChannelType) {
    ChannelConfigurationChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelConfigurationChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelConfigurationChannelType["EMAIL"] = "EMAIL";
    ChannelConfigurationChannelType["SMS"] = "SMS";
})(ChannelConfigurationChannelType = exports.ChannelConfigurationChannelType || (exports.ChannelConfigurationChannelType = {}));
var CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType;
(function (CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType) {
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["UNKNOWN_DIRECT_MESSAGE_TYPE"] = "UNKNOWN_DIRECT_MESSAGE_TYPE";
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["MEDIA"] = "MEDIA";
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["CARD"] = "CARD";
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["MINIMAL"] = "MINIMAL";
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["FORM"] = "FORM";
    CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType["SYSTEM"] = "SYSTEM";
})(CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType = exports.CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType || (exports.CommonsChannelAcceptedMessageTypesAcceptedDirectMessageType = {}));
var CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType;
(function (CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType) {
    CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType["UNKNOWN_SMS_MESSAGE_TYPE"] = "UNKNOWN_SMS_MESSAGE_TYPE";
    CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType["SMS"] = "SMS";
    CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType["MMS"] = "MMS";
})(CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType = exports.CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType || (exports.CommonsChannelAcceptedMessageTypesAcceptedSmsMessageType = {}));
var CommonsChannelMediaMimeType;
(function (CommonsChannelMediaMimeType) {
    CommonsChannelMediaMimeType["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
    CommonsChannelMediaMimeType["IMAGE_JPEG"] = "IMAGE_JPEG";
    CommonsChannelMediaMimeType["IMAGE_PNG"] = "IMAGE_PNG";
    CommonsChannelMediaMimeType["IMAGE_WEBP"] = "IMAGE_WEBP";
    CommonsChannelMediaMimeType["VIDEO_MPEG"] = "VIDEO_MPEG";
    CommonsChannelMediaMimeType["VIDEO_MP4"] = "VIDEO_MP4";
    CommonsChannelMediaMimeType["VIDEO_3GP"] = "VIDEO_3GP";
    CommonsChannelMediaMimeType["AUDIO_AAC"] = "AUDIO_AAC";
    CommonsChannelMediaMimeType["AUDIO_MP4"] = "AUDIO_MP4";
    CommonsChannelMediaMimeType["AUDIO_MPEG"] = "AUDIO_MPEG";
    CommonsChannelMediaMimeType["AUDIO_OGG"] = "AUDIO_OGG";
    CommonsChannelMediaMimeType["AUDIO_OPUS"] = "AUDIO_OPUS";
    CommonsChannelMediaMimeType["APPLICATION_PDF"] = "APPLICATION_PDF";
    CommonsChannelMediaMimeType["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(CommonsChannelMediaMimeType = exports.CommonsChannelMediaMimeType || (exports.CommonsChannelMediaMimeType = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["NONE"] = "NONE";
    ComponentType["STUDIO"] = "STUDIO";
    ComponentType["PLATFORM"] = "PLATFORM";
    ComponentType["WORKER"] = "WORKER";
    ComponentType["DASHBOARD"] = "DASHBOARD";
    ComponentType["WIDGET"] = "WIDGET";
    ComponentType["PAGE"] = "PAGE";
    ComponentType["DASHBOARD_PLATFORM"] = "DASHBOARD_PLATFORM";
    ComponentType["STUDIO_WIDGET"] = "STUDIO_WIDGET";
    ComponentType["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
    ComponentType["EXTENSION"] = "EXTENSION";
    ComponentType["SNIPPET_SOLUTION"] = "SNIPPET_SOLUTION";
    ComponentType["DATA_COMPONENT"] = "DATA_COMPONENT";
    ComponentType["WEB"] = "WEB";
    ComponentType["DC_CONFIG"] = "DC_CONFIG";
    ComponentType["WIDGET_OUT_OF_IFRAME"] = "WIDGET_OUT_OF_IFRAME";
    ComponentType["PAGE_OUT_OF_IFRAME"] = "PAGE_OUT_OF_IFRAME";
    ComponentType["STATIC_FILE"] = "STATIC_FILE";
    ComponentType["APP_CONFIG"] = "APP_CONFIG";
    ComponentType["MULTIPLE_DASHBOARDS"] = "MULTIPLE_DASHBOARDS";
    ComponentType["PAYMENTS_GATEWAY"] = "PAYMENTS_GATEWAY";
    ComponentType["CODE_PACKAGE"] = "CODE_PACKAGE";
    ComponentType["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
    ComponentType["INVOICES_ACTIONS"] = "INVOICES_ACTIONS";
    ComponentType["DASHBOARD_APPLICATION"] = "DASHBOARD_APPLICATION";
    ComponentType["CONTACT_LABELS"] = "CONTACT_LABELS";
    ComponentType["WIDGET_PLUGIN"] = "WIDGET_PLUGIN";
    ComponentType["CROSS_SELL"] = "CROSS_SELL";
    ComponentType["LOCAL_DELIVERY"] = "LOCAL_DELIVERY";
    ComponentType["PAYMENT_PROVIDER"] = "PAYMENT_PROVIDER";
    ComponentType["ECOM_MEMBERSHIPS"] = "ECOM_MEMBERSHIPS";
    ComponentType["ECOM_LINE_ITEMS_ENRICHER"] = "ECOM_LINE_ITEMS_ENRICHER";
    ComponentType["ECOM_SHIPPING_RATES"] = "ECOM_SHIPPING_RATES";
    ComponentType["SHIPPING_LABEL_CARRIER"] = "SHIPPING_LABEL_CARRIER";
    ComponentType["RESTAURANTS_POS"] = "RESTAURANTS_POS";
    ComponentType["FICTIONAL_SHIPPING_PROVIDER"] = "FICTIONAL_SHIPPING_PROVIDER";
    ComponentType["ALERT_ENRICHER"] = "ALERT_ENRICHER";
    ComponentType["DATA_EXTENSIONS"] = "DATA_EXTENSIONS";
    ComponentType["GENERIC_HOOKS"] = "GENERIC_HOOKS";
    ComponentType["AUTOMATIONS_ACTION_PROVIDER"] = "AUTOMATIONS_ACTION_PROVIDER";
    ComponentType["ECOM_CATALOG"] = "ECOM_CATALOG";
    ComponentType["BACK_OFFICE_EXTENSION_CONTAINER"] = "BACK_OFFICE_EXTENSION_CONTAINER";
    ComponentType["BACK_OFFICE_EXTENSION"] = "BACK_OFFICE_EXTENSION";
    ComponentType["AUTOMATIONS_TRIGGER_PROVIDER"] = "AUTOMATIONS_TRIGGER_PROVIDER";
    ComponentType["IDENTITY_PRE_REGISTRATION"] = "IDENTITY_PRE_REGISTRATION";
    ComponentType["PREMIUM_PRODUCTS_PATHS"] = "PREMIUM_PRODUCTS_PATHS";
    ComponentType["ECOM_CUSTOM_SCOPE"] = "ECOM_CUSTOM_SCOPE";
    ComponentType["GIFT_CARDS_PROVIDER"] = "GIFT_CARDS_PROVIDER";
    ComponentType["DEALER_EXTERNAL_FILTER_PROVIDER"] = "DEALER_EXTERNAL_FILTER_PROVIDER";
    ComponentType["ECOM_DROPSHIPPING_PROVIDER"] = "ECOM_DROPSHIPPING_PROVIDER";
    ComponentType["INVOICES_PROVIDER"] = "INVOICES_PROVIDER";
    ComponentType["SEO_KEYWORDS_SUGGESTIONS"] = "SEO_KEYWORDS_SUGGESTIONS";
    ComponentType["ECOM_DISCOUNTS_TRIGGER"] = "ECOM_DISCOUNTS_TRIGGER";
    ComponentType["MULTILINGUAL_CONTENT_PROVIDER"] = "MULTILINGUAL_CONTENT_PROVIDER";
    ComponentType["APPLICATION_AUTOMATION"] = "APPLICATION_AUTOMATION";
    ComponentType["BACK_OFFICE_SIDEBAR_CATEGORY"] = "BACK_OFFICE_SIDEBAR_CATEGORY";
    ComponentType["BACK_OFFICE_PAGE"] = "BACK_OFFICE_PAGE";
    ComponentType["ECOM_ADDITIONAL_FEES"] = "ECOM_ADDITIONAL_FEES";
    ComponentType["PING_USER_NOTIFICATION"] = "PING_USER_NOTIFICATION";
    ComponentType["ECOM_RECOMMENDATIONS_PROVIDER"] = "ECOM_RECOMMENDATIONS_PROVIDER";
    ComponentType["BOOKINGS_PRICING_PROVIDER"] = "BOOKINGS_PRICING_PROVIDER";
    ComponentType["IDENTITY_AUTHENTICATOR"] = "IDENTITY_AUTHENTICATOR";
    ComponentType["IDENTITY_IDP_CONNECTOR"] = "IDENTITY_IDP_CONNECTOR";
    ComponentType["ITEMS_SELECTION_PROVIDER"] = "ITEMS_SELECTION_PROVIDER";
    ComponentType["PORTFOLIO_SYNCED_PROJECTS_PROVIDER"] = "PORTFOLIO_SYNCED_PROJECTS_PROVIDER";
    ComponentType["COMMUNICATION_CHANNEL"] = "COMMUNICATION_CHANNEL";
    ComponentType["IDENTITY_POST_LOGIN"] = "IDENTITY_POST_LOGIN";
    ComponentType["BACK_OFFICE_WIDGET"] = "BACK_OFFICE_WIDGET";
    ComponentType["SOCIAL_MARKETING_DESIGN"] = "SOCIAL_MARKETING_DESIGN";
    ComponentType["FORMS_SUBMISSIONS_PROVIDER"] = "FORMS_SUBMISSIONS_PROVIDER";
    ComponentType["WIX_OFFERING"] = "WIX_OFFERING";
    ComponentType["DEV_CENTER_TESTING_COMPONENT"] = "DEV_CENTER_TESTING_COMPONENT";
    ComponentType["COMPONENTS_VALIDATOR_PROVIDER"] = "COMPONENTS_VALIDATOR_PROVIDER";
    ComponentType["COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER"] = "COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER";
    ComponentType["FORMS_SCHEMA_PROVIDER"] = "FORMS_SCHEMA_PROVIDER";
    ComponentType["BOOKINGS_EXTERNAL_CALENDAR_PROVIDER"] = "BOOKINGS_EXTERNAL_CALENDAR_PROVIDER";
    ComponentType["ECOM_DEFAULT_TAXATION_CATEGORY"] = "ECOM_DEFAULT_TAXATION_CATEGORY";
    ComponentType["VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER"] = "VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER";
    ComponentType["PING_UOU_NOTIFICATION"] = "PING_UOU_NOTIFICATION";
    ComponentType["HEADLESS_OAUTH"] = "HEADLESS_OAUTH";
    ComponentType["ECOM_TAX_CALCULATOR_SPI"] = "ECOM_TAX_CALCULATOR_SPI";
    ComponentType["COMMENTS_MODERATION_PROVIDER"] = "COMMENTS_MODERATION_PROVIDER";
    ComponentType["GRID_APP_FILES_TRANSFORMER"] = "GRID_APP_FILES_TRANSFORMER";
    ComponentType["BENEFIT_PROGRAMS_POLICY_PROVIDER"] = "BENEFIT_PROGRAMS_POLICY_PROVIDER";
    ComponentType["PREMIUM_CUSTOM_CHARGES"] = "PREMIUM_CUSTOM_CHARGES";
    ComponentType["ECOM_VALIDATIONS"] = "ECOM_VALIDATIONS";
    ComponentType["COMPONENT_REFERENCE_DATA_PROVIDER"] = "COMPONENT_REFERENCE_DATA_PROVIDER";
    ComponentType["WIX_REVIEWS_PRODUCT_CATALOG"] = "WIX_REVIEWS_PRODUCT_CATALOG";
    ComponentType["SOCIAL_MARKETING_DESIGNS_PROVIDER"] = "SOCIAL_MARKETING_DESIGNS_PROVIDER";
    ComponentType["GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER"] = "GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER";
    ComponentType["COMMENTS_FILTER_PROVIDER"] = "COMMENTS_FILTER_PROVIDER";
    ComponentType["BILLING_TAX_ID_VALIDATOR"] = "BILLING_TAX_ID_VALIDATOR";
    ComponentType["PING_SETTINGS_GROUP"] = "PING_SETTINGS_GROUP";
    ComponentType["FORMS_SPAM_SUBMISSIONS_PROVIDER"] = "FORMS_SPAM_SUBMISSIONS_PROVIDER";
    ComponentType["EDITOR_ADDON"] = "EDITOR_ADDON";
    ComponentType["EXTERNAL_DATABASE_PROVIDER"] = "EXTERNAL_DATABASE_PROVIDER";
    ComponentType["ECOM_PAYMENT_SETTINGS"] = "ECOM_PAYMENT_SETTINGS";
    ComponentType["NOTIFICATION_TOPIC"] = "NOTIFICATION_TOPIC";
    ComponentType["NOTIFICATION_PREFERENCES_FILTER_PROVIDER"] = "NOTIFICATION_PREFERENCES_FILTER_PROVIDER";
    ComponentType["BOOKINGS_RESOURCE_TYPES_PROVIDER"] = "BOOKINGS_RESOURCE_TYPES_PROVIDER";
    ComponentType["PRICING_PLANS_FORM_CONFIGURATION"] = "PRICING_PLANS_FORM_CONFIGURATION";
    ComponentType["USER_NOTIFICATION"] = "USER_NOTIFICATION";
    ComponentType["CONTACT_NOTIFICATION"] = "CONTACT_NOTIFICATION";
    ComponentType["UNIFIED_PAGE"] = "UNIFIED_PAGE";
    ComponentType["AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER"] = "AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER";
    ComponentType["PROPOSAL_EDITOR_PROVIDER"] = "PROPOSAL_EDITOR_PROVIDER";
    ComponentType["CUSTOM_TABLE_RESERVATIONS_PROVIDER"] = "CUSTOM_TABLE_RESERVATIONS_PROVIDER";
    ComponentType["COMMENTS_CONTEXT_PROVIDER"] = "COMMENTS_CONTEXT_PROVIDER";
    ComponentType["FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER"] = "FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER";
    ComponentType["AUTOMATIONS_VELO_ACTION_PROVIDER"] = "AUTOMATIONS_VELO_ACTION_PROVIDER";
    ComponentType["CALENDAR_EVENT_TYPE_PROVIDER"] = "CALENDAR_EVENT_TYPE_PROVIDER";
    ComponentType["RESERVED"] = "RESERVED";
    ComponentType["SMS_ACTION_MESSAGE"] = "SMS_ACTION_MESSAGE";
    ComponentType["BOOKING_POLICY_PROVIDER"] = "BOOKING_POLICY_PROVIDER";
    ComponentType["MULTI_SERVICE_BOOKING_POLICY_PROVIDER"] = "MULTI_SERVICE_BOOKING_POLICY_PROVIDER";
    ComponentType["AI_ASSISTANT"] = "AI_ASSISTANT";
    ComponentType["FORMS_SUBMISSIONS_EXTENSION_PROVIDER"] = "FORMS_SUBMISSIONS_EXTENSION_PROVIDER";
    ComponentType["MULTILINGUAL_TRANSLATION_SCHEMA"] = "MULTILINGUAL_TRANSLATION_SCHEMA";
    ComponentType["TAX_CALCULATION_PROVIDER"] = "TAX_CALCULATION_PROVIDER";
    ComponentType["TAX_GROUPS_PROVIDER"] = "TAX_GROUPS_PROVIDER";
    ComponentType["BACK_OFFICE_MODAL"] = "BACK_OFFICE_MODAL";
    ComponentType["DEPLOYMENT_PIPELINE_PROVIDER"] = "DEPLOYMENT_PIPELINE_PROVIDER";
    ComponentType["CUSTOM_ELEMENT_WIDGET"] = "CUSTOM_ELEMENT_WIDGET";
    ComponentType["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
    ComponentType["BACK_OFFICE_EXTENSION_MENU_ITEM"] = "BACK_OFFICE_EXTENSION_MENU_ITEM";
    ComponentType["FORM_TEMPLATE"] = "FORM_TEMPLATE";
    ComponentType["NOTIFICATION_CONTENT"] = "NOTIFICATION_CONTENT";
    ComponentType["BROADCAST_LIST"] = "BROADCAST_LIST";
    ComponentType["PARTNERS_PAYOUTS"] = "PARTNERS_PAYOUTS";
    ComponentType["WIX_REVIEWS_ENTITY_CATALOG"] = "WIX_REVIEWS_ENTITY_CATALOG";
    ComponentType["VELO_PUBLISH_PIPELINE_TASK_PROVIDER"] = "VELO_PUBLISH_PIPELINE_TASK_PROVIDER";
    ComponentType["FUNCTIONS_SHOP_PRICE_PROVIDER"] = "FUNCTIONS_SHOP_PRICE_PROVIDER";
    ComponentType["FUNCTION"] = "FUNCTION";
    ComponentType["ECOM_CHECKOUT_CONTENT"] = "ECOM_CHECKOUT_CONTENT";
    ComponentType["COMMUNICATION_CHANNEL_PROVIDER"] = "COMMUNICATION_CHANNEL_PROVIDER";
    ComponentType["WEBHOOK"] = "WEBHOOK";
    ComponentType["TOPOLOGY"] = "TOPOLOGY";
    ComponentType["LOYALTY_CUSTOM_REWARDS"] = "LOYALTY_CUSTOM_REWARDS";
    ComponentType["FUNCTION_RECIPE"] = "FUNCTION_RECIPE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ConnectMethod;
(function (ConnectMethod) {
    ConnectMethod["OAUTH"] = "OAUTH";
    ConnectMethod["CREDENTIALS"] = "CREDENTIALS";
})(ConnectMethod = exports.ConnectMethod || (exports.ConnectMethod = {}));
var ContactsNotificationDataInitiatorType;
(function (ContactsNotificationDataInitiatorType) {
    ContactsNotificationDataInitiatorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ContactsNotificationDataInitiatorType["CONTACT"] = "CONTACT";
    ContactsNotificationDataInitiatorType["SITE_MEMBER"] = "SITE_MEMBER";
})(ContactsNotificationDataInitiatorType = exports.ContactsNotificationDataInitiatorType || (exports.ContactsNotificationDataInitiatorType = {}));
var ContactsNotificationDataRecipientFilterType;
(function (ContactsNotificationDataRecipientFilterType) {
    ContactsNotificationDataRecipientFilterType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ContactsNotificationDataRecipientFilterType["CONTACTS"] = "CONTACTS";
})(ContactsNotificationDataRecipientFilterType = exports.ContactsNotificationDataRecipientFilterType || (exports.ContactsNotificationDataRecipientFilterType = {}));
var CustomElementScriptType;
(function (CustomElementScriptType) {
    CustomElementScriptType["NONE"] = "NONE";
    CustomElementScriptType["COMMON_JS"] = "COMMON_JS";
    CustomElementScriptType["ES_MODULE"] = "ES_MODULE";
})(CustomElementScriptType = exports.CustomElementScriptType || (exports.CustomElementScriptType = {}));
var Default;
(function (Default) {
    Default["WIX"] = "WIX";
    Default["POS"] = "POS";
})(Default = exports.Default || (exports.Default = {}));
var DefaultTextStyle;
(function (DefaultTextStyle) {
    DefaultTextStyle["TITLE"] = "TITLE";
    DefaultTextStyle["PARAGRAPH"] = "PARAGRAPH";
    DefaultTextStyle["LOWER_HIERARCHY_TEXTS"] = "LOWER_HIERARCHY_TEXTS";
})(DefaultTextStyle = exports.DefaultTextStyle || (exports.DefaultTextStyle = {}));
var ElementType;
(function (ElementType) {
    ElementType["WIDGET"] = "WIDGET";
    ElementType["PAGE"] = "PAGE";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
var EmbedCategory;
(function (EmbedCategory) {
    EmbedCategory["UNKNOWN"] = "UNKNOWN";
    EmbedCategory["ESSENTIAL"] = "ESSENTIAL";
    EmbedCategory["FUNCTIONAL"] = "FUNCTIONAL";
    EmbedCategory["ANALYTICS"] = "ANALYTICS";
    EmbedCategory["ADVERTISING"] = "ADVERTISING";
})(EmbedCategory = exports.EmbedCategory || (exports.EmbedCategory = {}));
var EmbeddedScriptPages;
(function (EmbeddedScriptPages) {
    EmbeddedScriptPages["NONE_PAGES"] = "NONE_PAGES";
    EmbeddedScriptPages["ONCE"] = "ONCE";
    EmbeddedScriptPages["SPECIFIC_PAGES"] = "SPECIFIC_PAGES";
})(EmbeddedScriptPages = exports.EmbeddedScriptPages || (exports.EmbeddedScriptPages = {}));
var EmbeddedScriptPlacement;
(function (EmbeddedScriptPlacement) {
    EmbeddedScriptPlacement["NONE_PLACEMENT"] = "NONE_PLACEMENT";
    EmbeddedScriptPlacement["HEAD"] = "HEAD";
    EmbeddedScriptPlacement["BODY_START"] = "BODY_START";
    EmbeddedScriptPlacement["BODY_END"] = "BODY_END";
})(EmbeddedScriptPlacement = exports.EmbeddedScriptPlacement || (exports.EmbeddedScriptPlacement = {}));
var Environment;
(function (Environment) {
    Environment["LIVE_SITE"] = "LIVE_SITE";
    Environment["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
})(Environment = exports.Environment || (exports.Environment = {}));
var ExecutionType;
(function (ExecutionType) {
    ExecutionType["UNKNOWN_EXECUTION_TYPE"] = "UNKNOWN_EXECUTION_TYPE";
    ExecutionType["SYNC"] = "SYNC";
    ExecutionType["ASYNC"] = "ASYNC";
})(ExecutionType = exports.ExecutionType || (exports.ExecutionType = {}));
var Exposure;
(function (Exposure) {
    Exposure["UNKNOWN_EXPOSURE"] = "UNKNOWN_EXPOSURE";
    Exposure["SETUP"] = "SETUP";
    Exposure["HIDDEN"] = "HIDDEN";
    Exposure["EXPOSED"] = "EXPOSED";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var ExposureRuleType;
(function (ExposureRuleType) {
    ExposureRuleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ExposureRuleType["OPEN_TO_ALL"] = "OPEN_TO_ALL";
    ExposureRuleType["OPEN_TO_NONE"] = "OPEN_TO_NONE";
    ExposureRuleType["BOOLEAN_EXPERIMENT"] = "BOOLEAN_EXPERIMENT";
    ExposureRuleType["CUSTOM_EXPERIMENT"] = "CUSTOM_EXPERIMENT";
})(ExposureRuleType = exports.ExposureRuleType || (exports.ExposureRuleType = {}));
var ExtendingComponentType;
(function (ExtendingComponentType) {
    ExtendingComponentType["INVALID"] = "INVALID";
    ExtendingComponentType["BACK_OFFICE_MENU_ITEM"] = "BACK_OFFICE_MENU_ITEM";
    ExtendingComponentType["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
})(ExtendingComponentType = exports.ExtendingComponentType || (exports.ExtendingComponentType = {}));
var ExtensionType;
(function (ExtensionType) {
    ExtensionType["NONE_EXTENSION"] = "NONE_EXTENSION";
    ExtensionType["PAYMENTS_GATEWAY_EXTENSION"] = "PAYMENTS_GATEWAY_EXTENSION";
    ExtensionType["COUPONS_EXTENSION"] = "COUPONS_EXTENSION";
    ExtensionType["DROPSHIPPING_EXTENSION"] = "DROPSHIPPING_EXTENSION";
    ExtensionType["FULFILMENT_EXTENSION"] = "FULFILMENT_EXTENSION";
    ExtensionType["DROPSHIPPING_SUPPLIER_EXTENSION"] = "DROPSHIPPING_SUPPLIER_EXTENSION";
    ExtensionType["FULFILLMENT_CENTER_EXTENSION"] = "FULFILLMENT_CENTER_EXTENSION";
    ExtensionType["RESTAURANTS_POS_EXTENSION"] = "RESTAURANTS_POS_EXTENSION";
    ExtensionType["ART_STORE_EXTENSION"] = "ART_STORE_EXTENSION";
    ExtensionType["ASCEND_AUTOMATION_EXTENSION"] = "ASCEND_AUTOMATION_EXTENSION";
    ExtensionType["CONTACT_LABELS_EXTENSION"] = "CONTACT_LABELS_EXTENSION";
})(ExtensionType = exports.ExtensionType || (exports.ExtensionType = {}));
var FieldType;
(function (FieldType) {
    FieldType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    FieldType["SHORT_TEXT"] = "SHORT_TEXT";
    FieldType["LONG_TEXT"] = "LONG_TEXT";
    FieldType["HTML"] = "HTML";
    FieldType["RICH_CONTENT"] = "RICH_CONTENT";
    FieldType["IMAGE"] = "IMAGE";
    FieldType["IMAGE_LINK"] = "IMAGE_LINK";
    FieldType["JSON"] = "JSON";
    FieldType["VIDEO"] = "VIDEO";
    FieldType["DOCUMENT"] = "DOCUMENT";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var FilterOptionsType;
(function (FilterOptionsType) {
    FilterOptionsType["UNKNOWN_FILTER_OPTIONS"] = "UNKNOWN_FILTER_OPTIONS";
    FilterOptionsType["STATIC"] = "STATIC";
})(FilterOptionsType = exports.FilterOptionsType || (exports.FilterOptionsType = {}));
var FilterSelectionType;
(function (FilterSelectionType) {
    FilterSelectionType["UNKNOWN_SELECTION"] = "UNKNOWN_SELECTION";
    FilterSelectionType["SINGLE_SELECTION"] = "SINGLE_SELECTION";
})(FilterSelectionType = exports.FilterSelectionType || (exports.FilterSelectionType = {}));
var HeightMode;
(function (HeightMode) {
    HeightMode["UNKNOWN"] = "UNKNOWN";
    HeightMode["AUTO"] = "AUTO";
    HeightMode["FIXED"] = "FIXED";
})(HeightMode = exports.HeightMode || (exports.HeightMode = {}));
var HookType;
(function (HookType) {
    HookType["UNDEFINED"] = "UNDEFINED";
    HookType["BEFORE_BLOCKING"] = "BEFORE_BLOCKING";
    HookType["BEFORE"] = "BEFORE";
    HookType["AFTER"] = "AFTER";
})(HookType = exports.HookType || (exports.HookType = {}));
var HorizontalDocking;
(function (HorizontalDocking) {
    HorizontalDocking["NO_HDOCKING"] = "NO_HDOCKING";
    HorizontalDocking["LEFT_DOCKING"] = "LEFT_DOCKING";
    HorizontalDocking["HCENTER"] = "HCENTER";
    HorizontalDocking["RIGHT_DOCKING"] = "RIGHT_DOCKING";
})(HorizontalDocking = exports.HorizontalDocking || (exports.HorizontalDocking = {}));
var HostContainerId;
(function (HostContainerId) {
    HostContainerId["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    HostContainerId["BUSINESS_DASHBOARD_HOST"] = "BUSINESS_DASHBOARD_HOST";
    HostContainerId["SIDEBAR_FOOTER"] = "SIDEBAR_FOOTER";
})(HostContainerId = exports.HostContainerId || (exports.HostContainerId = {}));
var IconType;
(function (IconType) {
    IconType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    IconType["URL"] = "URL";
    IconType["SPOUT"] = "SPOUT";
    IconType["INITIATOR"] = "INITIATOR";
})(IconType = exports.IconType || (exports.IconType = {}));
var ImageShape;
(function (ImageShape) {
    ImageShape["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
    ImageShape["CIRCLE"] = "CIRCLE";
    ImageShape["SQUARE"] = "SQUARE";
    ImageShape["RECTANGLE"] = "RECTANGLE";
})(ImageShape = exports.ImageShape || (exports.ImageShape = {}));
var IncompleteSetupReason;
(function (IncompleteSetupReason) {
    IncompleteSetupReason["NO_REASON"] = "NO_REASON";
    IncompleteSetupReason["PENDING_CONSENT"] = "PENDING_CONSENT";
    IncompleteSetupReason["PENDING_CONFIGURATION"] = "PENDING_CONFIGURATION";
})(IncompleteSetupReason = exports.IncompleteSetupReason || (exports.IncompleteSetupReason = {}));
var InitDirection;
(function (InitDirection) {
    InitDirection["UNKNOWN_INIT_DIRECTION"] = "UNKNOWN_INIT_DIRECTION";
    InitDirection["BUSINESS"] = "BUSINESS";
    InitDirection["CUSTOMER"] = "CUSTOMER";
    InitDirection["BOTH"] = "BOTH";
})(InitDirection = exports.InitDirection || (exports.InitDirection = {}));
var InstallPage;
(function (InstallPage) {
    InstallPage["NO_PAGE"] = "NO_PAGE";
    InstallPage["CURRENT"] = "CURRENT";
    InstallPage["PAGE"] = "PAGE";
    InstallPage["LIGHTBOX"] = "LIGHTBOX";
})(InstallPage = exports.InstallPage || (exports.InstallPage = {}));
var Intent;
(function (Intent) {
    Intent["UNKNOWN_INTENT"] = "UNKNOWN_INTENT";
    Intent["MARKETING"] = "MARKETING";
    Intent["TRANSACTIONAL"] = "TRANSACTIONAL";
})(Intent = exports.Intent || (exports.Intent = {}));
var InterfaceConfigurationType;
(function (InterfaceConfigurationType) {
    InterfaceConfigurationType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    InterfaceConfigurationType["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
    InterfaceConfigurationType["GENERIC"] = "GENERIC";
})(InterfaceConfigurationType = exports.InterfaceConfigurationType || (exports.InterfaceConfigurationType = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    IntervalUnit["DAY"] = "DAY";
    IntervalUnit["WEEK"] = "WEEK";
    IntervalUnit["MONTH"] = "MONTH";
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit = exports.IntervalUnit || (exports.IntervalUnit = {}));
var ItemsSelectionProviderConfigTag;
(function (ItemsSelectionProviderConfigTag) {
    ItemsSelectionProviderConfigTag["UNKNOWN_TAG"] = "UNKNOWN_TAG";
    ItemsSelectionProviderConfigTag["EMBEDDABLE"] = "EMBEDDABLE";
    ItemsSelectionProviderConfigTag["ECOM_EDIT_ORDER"] = "ECOM_EDIT_ORDER";
    ItemsSelectionProviderConfigTag["ECOM_CREATE_ORDER"] = "ECOM_CREATE_ORDER";
    ItemsSelectionProviderConfigTag["INBOX"] = "INBOX";
})(ItemsSelectionProviderConfigTag = exports.ItemsSelectionProviderConfigTag || (exports.ItemsSelectionProviderConfigTag = {}));
var Level;
(function (Level) {
    Level["UNKNOWN_LEVEL"] = "UNKNOWN_LEVEL";
    Level["ACCOUNT"] = "ACCOUNT";
    Level["USER"] = "USER";
    Level["SITE"] = "SITE";
})(Level = exports.Level || (exports.Level = {}));
var ListEventFromCalendars;
(function (ListEventFromCalendars) {
    ListEventFromCalendars["LIST_NOT_SUPPORTED"] = "LIST_NOT_SUPPORTED";
    ListEventFromCalendars["LIST_FROM_PRIMARY_CALENDAR_ONLY"] = "LIST_FROM_PRIMARY_CALENDAR_ONLY";
    ListEventFromCalendars["LIST_FROM_SPECIFIC_CALENDARS"] = "LIST_FROM_SPECIFIC_CALENDARS";
})(ListEventFromCalendars = exports.ListEventFromCalendars || (exports.ListEventFromCalendars = {}));
var LockableOperation;
(function (LockableOperation) {
    LockableOperation["UNSPECIFIED_LOCKABLE"] = "UNSPECIFIED_LOCKABLE";
    LockableOperation["LOCKED"] = "LOCKED";
    LockableOperation["UNLOCKED"] = "UNLOCKED";
})(LockableOperation = exports.LockableOperation || (exports.LockableOperation = {}));
var MandatoryField;
(function (MandatoryField) {
    MandatoryField["ZIPCODE"] = "ZIPCODE";
    MandatoryField["CITY"] = "CITY";
    MandatoryField["STATE"] = "STATE";
    MandatoryField["ADDRESS"] = "ADDRESS";
    MandatoryField["COUNTRY_CODE"] = "COUNTRY_CODE";
    MandatoryField["EMAIL"] = "EMAIL";
    MandatoryField["PHONE"] = "PHONE";
    MandatoryField["FIRST_NAME"] = "FIRST_NAME";
    MandatoryField["LAST_NAME"] = "LAST_NAME";
    MandatoryField["STREET"] = "STREET";
    MandatoryField["HOUSE_NUMBER"] = "HOUSE_NUMBER";
    MandatoryField["TAX_IDENTIFIER"] = "TAX_IDENTIFIER";
})(MandatoryField = exports.MandatoryField || (exports.MandatoryField = {}));
var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["Metric"] = "Metric";
    MeasurementSystem["Imperial"] = "Imperial";
})(MeasurementSystem = exports.MeasurementSystem || (exports.MeasurementSystem = {}));
var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var MobileApplication;
(function (MobileApplication) {
    MobileApplication["UNKNOWN_MOBILE_APPLICATION"] = "UNKNOWN_MOBILE_APPLICATION";
    MobileApplication["OWNER"] = "OWNER";
    MobileApplication["SPACES"] = "SPACES";
    MobileApplication["DINE"] = "DINE";
    MobileApplication["FITNESS"] = "FITNESS";
    MobileApplication["WIX_LIFE"] = "WIX_LIFE";
    MobileApplication["WIX_PARTNERS"] = "WIX_PARTNERS";
    MobileApplication["BRANDED"] = "BRANDED";
    MobileApplication["WIX_STUDIO"] = "WIX_STUDIO";
    MobileApplication["NO_SPECIFIC_TARGET_APP"] = "NO_SPECIFIC_TARGET_APP";
})(MobileApplication = exports.MobileApplication || (exports.MobileApplication = {}));
var NavigationType;
(function (NavigationType) {
    NavigationType["NAVIGATE"] = "NAVIGATE";
    NavigationType["MODAL"] = "MODAL";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));
var NotificationTopicState;
(function (NotificationTopicState) {
    NotificationTopicState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    NotificationTopicState["DEFAULT_ON"] = "DEFAULT_ON";
    NotificationTopicState["DEFAULT_OFF"] = "DEFAULT_OFF";
    NotificationTopicState["ALWAYS_ON"] = "ALWAYS_ON";
})(NotificationTopicState = exports.NotificationTopicState || (exports.NotificationTopicState = {}));
var NotificationTopicType;
(function (NotificationTopicType) {
    NotificationTopicType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    NotificationTopicType["PROMOTIONAL"] = "PROMOTIONAL";
    NotificationTopicType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(NotificationTopicType = exports.NotificationTopicType || (exports.NotificationTopicType = {}));
var OAuthAppType;
(function (OAuthAppType) {
    OAuthAppType["OAUTH_APP_TYPE_UNSPECIFIED"] = "OAUTH_APP_TYPE_UNSPECIFIED";
    OAuthAppType["WEB_APP"] = "WEB_APP";
    OAuthAppType["MOBILE"] = "MOBILE";
    OAuthAppType["OTHER"] = "OTHER";
})(OAuthAppType = exports.OAuthAppType || (exports.OAuthAppType = {}));
var OAuthTechnologies;
(function (OAuthTechnologies) {
    OAuthTechnologies["OAUTH_TECHNOLOGY_UNSPECIFIED"] = "OAUTH_TECHNOLOGY_UNSPECIFIED";
    OAuthTechnologies["JAVASCRIPT"] = "JAVASCRIPT";
    OAuthTechnologies["ANGULAR"] = "ANGULAR";
    OAuthTechnologies["VUE"] = "VUE";
    OAuthTechnologies["REACT"] = "REACT";
    OAuthTechnologies["REACT_NATIVE"] = "REACT_NATIVE";
    OAuthTechnologies["IOS"] = "IOS";
    OAuthTechnologies["ANDROID"] = "ANDROID";
    OAuthTechnologies["OTHER_TECHNOLOGY"] = "OTHER_TECHNOLOGY";
})(OAuthTechnologies = exports.OAuthTechnologies || (exports.OAuthTechnologies = {}));
var OpenConsentIn;
(function (OpenConsentIn) {
    OpenConsentIn["NONE_VALUE"] = "NONE_VALUE";
    OpenConsentIn["NEW_WINDOW"] = "NEW_WINDOW";
    OpenConsentIn["NEW_TAB"] = "NEW_TAB";
})(OpenConsentIn = exports.OpenConsentIn || (exports.OpenConsentIn = {}));
var Order;
(function (Order) {
    Order["NONE_ORDER"] = "NONE_ORDER";
    Order["MOST_POPULAR"] = "MOST_POPULAR";
    Order["GEO"] = "GEO";
    Order["RANDOM"] = "RANDOM";
})(Order = exports.Order || (exports.Order = {}));
var PartialPaymentRestriction;
(function (PartialPaymentRestriction) {
    PartialPaymentRestriction["UNDEFINED"] = "UNDEFINED";
    PartialPaymentRestriction["ALLOW"] = "ALLOW";
    PartialPaymentRestriction["DISALLOW"] = "DISALLOW";
})(PartialPaymentRestriction = exports.PartialPaymentRestriction || (exports.PartialPaymentRestriction = {}));
var PaymentCollectionType;
(function (PaymentCollectionType) {
    PaymentCollectionType["PMT_UNKNOWN"] = "PMT_UNKNOWN";
    PaymentCollectionType["SUBSCRIPTION"] = "SUBSCRIPTION";
    PaymentCollectionType["NON_PAYABLE"] = "NON_PAYABLE";
    PaymentCollectionType["ONE_TIME"] = "ONE_TIME";
})(PaymentCollectionType = exports.PaymentCollectionType || (exports.PaymentCollectionType = {}));
var PingSettingsGroupComponentDataState;
(function (PingSettingsGroupComponentDataState) {
    PingSettingsGroupComponentDataState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    PingSettingsGroupComponentDataState["DEFAULT_ON"] = "DEFAULT_ON";
    PingSettingsGroupComponentDataState["DEFAULT_OFF"] = "DEFAULT_OFF";
    PingSettingsGroupComponentDataState["ALWAYS_ON"] = "ALWAYS_ON";
})(PingSettingsGroupComponentDataState = exports.PingSettingsGroupComponentDataState || (exports.PingSettingsGroupComponentDataState = {}));
var PlanDescription;
(function (PlanDescription) {
    PlanDescription["UNKNOWN_DESCRIPTION"] = "UNKNOWN_DESCRIPTION";
    PlanDescription["BENEFITS"] = "BENEFITS";
    PlanDescription["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(PlanDescription = exports.PlanDescription || (exports.PlanDescription = {}));
var PlanFormDefaultSection;
(function (PlanFormDefaultSection) {
    PlanFormDefaultSection["UNKNWON_PLAN_FORM_SECTION"] = "UNKNWON_PLAN_FORM_SECTION";
    PlanFormDefaultSection["INFO"] = "INFO";
    PlanFormDefaultSection["BENEFITS"] = "BENEFITS";
    PlanFormDefaultSection["PAGE_PERMISSIONS"] = "PAGE_PERMISSIONS";
    PlanFormDefaultSection["PRICING_AND_DURATION"] = "PRICING_AND_DURATION";
    PlanFormDefaultSection["ADVANCED_SETTINGS"] = "ADVANCED_SETTINGS";
})(PlanFormDefaultSection = exports.PlanFormDefaultSection || (exports.PlanFormDefaultSection = {}));
var PlanFormPricingOption;
(function (PlanFormPricingOption) {
    PlanFormPricingOption["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
    PlanFormPricingOption["FREE"] = "FREE";
    PlanFormPricingOption["ONE_TIME"] = "ONE_TIME";
    PlanFormPricingOption["RECURRING"] = "RECURRING";
})(PlanFormPricingOption = exports.PlanFormPricingOption || (exports.PlanFormPricingOption = {}));
var PlanPeriodUnit;
(function (PlanPeriodUnit) {
    PlanPeriodUnit["UNDEFINED"] = "UNDEFINED";
    PlanPeriodUnit["DAY"] = "DAY";
    PlanPeriodUnit["WEEK"] = "WEEK";
    PlanPeriodUnit["MONTH"] = "MONTH";
    PlanPeriodUnit["YEAR"] = "YEAR";
})(PlanPeriodUnit = exports.PlanPeriodUnit || (exports.PlanPeriodUnit = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["NONE_PLATFORM"] = "NONE_PLATFORM";
    PlatformType["EDITOR_PLATFORM"] = "EDITOR_PLATFORM";
    PlatformType["STAND_ALONE_PLATFORM"] = "STAND_ALONE_PLATFORM";
    PlatformType["BUSINESS_MANAGER_PLATFORM"] = "BUSINESS_MANAGER_PLATFORM";
    PlatformType["WIX_INTERNAL"] = "WIX_INTERNAL";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var PluginInterface;
(function (PluginInterface) {
    PluginInterface["NONE_INTERFACE"] = "NONE_INTERFACE";
    PluginInterface["REVIEWS"] = "REVIEWS";
    PluginInterface["RATINGS_SUMMARY"] = "RATINGS_SUMMARY";
    PluginInterface["RATINGS_SUMMARY_OOI_LIST"] = "RATINGS_SUMMARY_OOI_LIST";
    PluginInterface["BOOKINGS_SERVICE"] = "BOOKINGS_SERVICE";
    PluginInterface["BOOKINGS_FORM"] = "BOOKINGS_FORM";
    PluginInterface["BASE"] = "BASE";
    PluginInterface["EVENT"] = "EVENT";
    PluginInterface["PRODUCT"] = "PRODUCT";
    PluginInterface["CHECKOUT"] = "CHECKOUT";
    PluginInterface["CATEGORY"] = "CATEGORY";
    PluginInterface["BOOKINGS_CALENDAR"] = "BOOKINGS_CALENDAR";
})(PluginInterface = exports.PluginInterface || (exports.PluginInterface = {}));
var PrimitiveType;
(function (PrimitiveType) {
    PrimitiveType["UNKNOWN_PRIMITIVE_TYPE"] = "UNKNOWN_PRIMITIVE_TYPE";
    PrimitiveType["TEXT"] = "TEXT";
    PrimitiveType["BOOLEAN"] = "BOOLEAN";
    PrimitiveType["NUMBER"] = "NUMBER";
})(PrimitiveType = exports.PrimitiveType || (exports.PrimitiveType = {}));
var Region;
(function (Region) {
    Region["no_region"] = "no_region";
    Region["header"] = "header";
    Region["pageContainer"] = "pageContainer";
    Region["footer"] = "footer";
})(Region = exports.Region || (exports.Region = {}));
var RegionType;
(function (RegionType) {
    RegionType["HEADER"] = "HEADER";
    RegionType["BODY"] = "BODY";
    RegionType["FOOTER"] = "FOOTER";
})(RegionType = exports.RegionType || (exports.RegionType = {}));
var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN"] = "UNKNOWN";
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType = exports.RenewalType || (exports.RenewalType = {}));
var ReplacementType;
(function (ReplacementType) {
    ReplacementType["UNKNOWN_REPLACEMENT"] = "UNKNOWN_REPLACEMENT";
    ReplacementType["REPLACING"] = "REPLACING";
    ReplacementType["REPLACEABLE"] = "REPLACEABLE";
})(ReplacementType = exports.ReplacementType || (exports.ReplacementType = {}));
var RestrictedOperation;
(function (RestrictedOperation) {
    RestrictedOperation["UNSPECIFIED_RESTRICTED"] = "UNSPECIFIED_RESTRICTED";
    RestrictedOperation["ALLOW"] = "ALLOW";
    RestrictedOperation["WARN"] = "WARN";
})(RestrictedOperation = exports.RestrictedOperation || (exports.RestrictedOperation = {}));
var SchemaScope;
(function (SchemaScope) {
    SchemaScope["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
    SchemaScope["GLOBAL"] = "GLOBAL";
    SchemaScope["SITE"] = "SITE";
})(SchemaScope = exports.SchemaScope || (exports.SchemaScope = {}));
var ScriptType;
(function (ScriptType) {
    ScriptType["NO_SCRIPT_TYPE"] = "NO_SCRIPT_TYPE";
    ScriptType["MODULE"] = "MODULE";
})(ScriptType = exports.ScriptType || (exports.ScriptType = {}));
var SimpleType;
(function (SimpleType) {
    SimpleType["UNKNOWN_SIMPLE_TYPE"] = "UNKNOWN_SIMPLE_TYPE";
    SimpleType["MONEY"] = "MONEY";
    SimpleType["LINK"] = "LINK";
    SimpleType["BACKOFFICE_LINK"] = "BACKOFFICE_LINK";
    SimpleType["LIVESITE_LINK"] = "LIVESITE_LINK";
    SimpleType["MULTILINGUAL"] = "MULTILINGUAL";
    SimpleType["IMAGE_LINK"] = "IMAGE_LINK";
    SimpleType["GUID"] = "GUID";
    SimpleType["EMAIL"] = "EMAIL";
    SimpleType["PHONE"] = "PHONE";
    SimpleType["CONTACT_ID"] = "CONTACT_ID";
})(SimpleType = exports.SimpleType || (exports.SimpleType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["INACTIVE"] = "INACTIVE";
})(Status = exports.Status || (exports.Status = {}));
var SyncToCalendar;
(function (SyncToCalendar) {
    SyncToCalendar["SYNC_NOT_SUPPORTED"] = "SYNC_NOT_SUPPORTED";
    SyncToCalendar["SYNC_TO_PRIMARY_CALENDAR_ONLY"] = "SYNC_TO_PRIMARY_CALENDAR_ONLY";
    SyncToCalendar["SYNC_TO_DEDICATED_CALENDAR"] = "SYNC_TO_DEDICATED_CALENDAR";
})(SyncToCalendar = exports.SyncToCalendar || (exports.SyncToCalendar = {}));
var TagType;
(function (TagType) {
    TagType["NONE_TAG"] = "NONE_TAG";
    TagType["CATEGORY"] = "CATEGORY";
    TagType["COLLECTION"] = "COLLECTION";
})(TagType = exports.TagType || (exports.TagType = {}));
var TaxSettingsTaxType;
(function (TaxSettingsTaxType) {
    TaxSettingsTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxSettingsTaxType["VAT"] = "VAT";
    TaxSettingsTaxType["GST"] = "GST";
})(TaxSettingsTaxType = exports.TaxSettingsTaxType || (exports.TaxSettingsTaxType = {}));
var TaxTypeConfigurationTaxType;
(function (TaxTypeConfigurationTaxType) {
    TaxTypeConfigurationTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxTypeConfigurationTaxType["REGULAR"] = "REGULAR";
    TaxTypeConfigurationTaxType["EU_VAT"] = "EU_VAT";
    TaxTypeConfigurationTaxType["JAPAN_JCT"] = "JAPAN_JCT";
    TaxTypeConfigurationTaxType["AU_GST"] = "AU_GST";
    TaxTypeConfigurationTaxType["BR_CNPJ"] = "BR_CNPJ";
    TaxTypeConfigurationTaxType["RU_TIN"] = "RU_TIN";
    TaxTypeConfigurationTaxType["IN_RNR"] = "IN_RNR";
    TaxTypeConfigurationTaxType["IL_VAT"] = "IL_VAT";
    TaxTypeConfigurationTaxType["US_TAX"] = "US_TAX";
    TaxTypeConfigurationTaxType["SG_GST"] = "SG_GST";
    TaxTypeConfigurationTaxType["CA_GST"] = "CA_GST";
    TaxTypeConfigurationTaxType["CA_HST"] = "CA_HST";
    TaxTypeConfigurationTaxType["CA_PST"] = "CA_PST";
    TaxTypeConfigurationTaxType["CA_QST"] = "CA_QST";
    TaxTypeConfigurationTaxType["NZ_GST"] = "NZ_GST";
    TaxTypeConfigurationTaxType["MD_VAT"] = "MD_VAT";
    TaxTypeConfigurationTaxType["CL_VAT"] = "CL_VAT";
    TaxTypeConfigurationTaxType["MY_VAT"] = "MY_VAT";
    TaxTypeConfigurationTaxType["KR_VAT"] = "KR_VAT";
    TaxTypeConfigurationTaxType["TW_VAT"] = "TW_VAT";
    TaxTypeConfigurationTaxType["AE_VAT"] = "AE_VAT";
    TaxTypeConfigurationTaxType["NG_VAT"] = "NG_VAT";
    TaxTypeConfigurationTaxType["IS_VAT"] = "IS_VAT";
    TaxTypeConfigurationTaxType["GE_VAT"] = "GE_VAT";
    TaxTypeConfigurationTaxType["TH_VAT"] = "TH_VAT";
    TaxTypeConfigurationTaxType["TR_VAT"] = "TR_VAT";
    TaxTypeConfigurationTaxType["NO_VAT"] = "NO_VAT";
    TaxTypeConfigurationTaxType["UA_VAT"] = "UA_VAT";
    TaxTypeConfigurationTaxType["IN_GST"] = "IN_GST";
    TaxTypeConfigurationTaxType["KZ_VAT"] = "KZ_VAT";
})(TaxTypeConfigurationTaxType = exports.TaxTypeConfigurationTaxType || (exports.TaxTypeConfigurationTaxType = {}));
var TemplateDefaultColor;
(function (TemplateDefaultColor) {
    TemplateDefaultColor["BACKGROUND"] = "BACKGROUND";
    TemplateDefaultColor["SECONDARY_TEXTS"] = "SECONDARY_TEXTS";
    TemplateDefaultColor["MAIN_TEXT_AND_ICONS"] = "MAIN_TEXT_AND_ICONS";
    TemplateDefaultColor["BORDERS_AND_DIVIDERS"] = "BORDERS_AND_DIVIDERS";
    TemplateDefaultColor["BUTTONS_AND_LINKS"] = "BUTTONS_AND_LINKS";
})(TemplateDefaultColor = exports.TemplateDefaultColor || (exports.TemplateDefaultColor = {}));
var TextInputDisplayType;
(function (TextInputDisplayType) {
    TextInputDisplayType["TEXT"] = "TEXT";
    TextInputDisplayType["PASSWORD"] = "PASSWORD";
    TextInputDisplayType["CODE"] = "CODE";
})(TextInputDisplayType = exports.TextInputDisplayType || (exports.TextInputDisplayType = {}));
var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType["UNKNOWN_THUMBNAIL_TYPE"] = "UNKNOWN_THUMBNAIL_TYPE";
    ThumbnailType["IMAGE"] = "IMAGE";
    ThumbnailType["AVATAR"] = "AVATAR";
})(ThumbnailType = exports.ThumbnailType || (exports.ThumbnailType = {}));
var ThumbnailsSize;
(function (ThumbnailsSize) {
    ThumbnailsSize["SMALL"] = "SMALL";
    ThumbnailsSize["MEDIUM"] = "MEDIUM";
    ThumbnailsSize["LARGE"] = "LARGE";
    ThumbnailsSize["XLARGE"] = "XLARGE";
})(ThumbnailsSize = exports.ThumbnailsSize || (exports.ThumbnailsSize = {}));
var TypedDynamicParamType;
(function (TypedDynamicParamType) {
    TypedDynamicParamType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    TypedDynamicParamType["STRING"] = "STRING";
    TypedDynamicParamType["ARRAY"] = "ARRAY";
})(TypedDynamicParamType = exports.TypedDynamicParamType || (exports.TypedDynamicParamType = {}));
var UninstallActions;
(function (UninstallActions) {
    UninstallActions["NONE_ACTION"] = "NONE_ACTION";
    UninstallActions["NO_ACTION"] = "NO_ACTION";
    UninstallActions["REMOVE_ALL_PRODUCT"] = "REMOVE_ALL_PRODUCT";
    UninstallActions["SHIPPING_RATES_REGION"] = "SHIPPING_RATES_REGION";
})(UninstallActions = exports.UninstallActions || (exports.UninstallActions = {}));
var UnitType;
(function (UnitType) {
    UnitType["NO_UNIT"] = "NO_UNIT";
    UnitType["AUTO"] = "AUTO";
    UnitType["PX"] = "PX";
    UnitType["VH"] = "VH";
    UnitType["VW"] = "VW";
    UnitType["PERCENTAGE"] = "PERCENTAGE";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
var UserNotificationDataInitiatorType;
(function (UserNotificationDataInitiatorType) {
    UserNotificationDataInitiatorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataInitiatorType["WIX_USER"] = "WIX_USER";
    UserNotificationDataInitiatorType["WIX_APP"] = "WIX_APP";
})(UserNotificationDataInitiatorType = exports.UserNotificationDataInitiatorType || (exports.UserNotificationDataInitiatorType = {}));
var UserNotificationDataRecipientFilterType;
(function (UserNotificationDataRecipientFilterType) {
    UserNotificationDataRecipientFilterType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataRecipientFilterType["WIX_USERS"] = "WIX_USERS";
    UserNotificationDataRecipientFilterType["SITE_CONTRIBUTORS"] = "SITE_CONTRIBUTORS";
})(UserNotificationDataRecipientFilterType = exports.UserNotificationDataRecipientFilterType || (exports.UserNotificationDataRecipientFilterType = {}));
var UserNotificationDataType;
(function (UserNotificationDataType) {
    UserNotificationDataType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataType["REGULAR"] = "REGULAR";
    UserNotificationDataType["ALERT_WARNING"] = "ALERT_WARNING";
    UserNotificationDataType["ALERT_INFO"] = "ALERT_INFO";
})(UserNotificationDataType = exports.UserNotificationDataType || (exports.UserNotificationDataType = {}));
var V1ChannelAcceptedMessageTypesAcceptedDirectMessageType;
(function (V1ChannelAcceptedMessageTypesAcceptedDirectMessageType) {
    V1ChannelAcceptedMessageTypesAcceptedDirectMessageType["TEXT"] = "TEXT";
    V1ChannelAcceptedMessageTypesAcceptedDirectMessageType["MEDIA"] = "MEDIA";
    V1ChannelAcceptedMessageTypesAcceptedDirectMessageType["CARD"] = "CARD";
    V1ChannelAcceptedMessageTypesAcceptedDirectMessageType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    V1ChannelAcceptedMessageTypesAcceptedDirectMessageType["FORM"] = "FORM";
})(V1ChannelAcceptedMessageTypesAcceptedDirectMessageType = exports.V1ChannelAcceptedMessageTypesAcceptedDirectMessageType || (exports.V1ChannelAcceptedMessageTypesAcceptedDirectMessageType = {}));
var V1ChannelAcceptedMessageTypesAcceptedSmsMessageType;
(function (V1ChannelAcceptedMessageTypesAcceptedSmsMessageType) {
    V1ChannelAcceptedMessageTypesAcceptedSmsMessageType["SMS"] = "SMS";
    V1ChannelAcceptedMessageTypesAcceptedSmsMessageType["MMS"] = "MMS";
})(V1ChannelAcceptedMessageTypesAcceptedSmsMessageType = exports.V1ChannelAcceptedMessageTypesAcceptedSmsMessageType || (exports.V1ChannelAcceptedMessageTypesAcceptedSmsMessageType = {}));
var V1ChannelMediaMimeType;
(function (V1ChannelMediaMimeType) {
    V1ChannelMediaMimeType["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
    V1ChannelMediaMimeType["IMAGE_JPEG"] = "IMAGE_JPEG";
    V1ChannelMediaMimeType["IMAGE_PNG"] = "IMAGE_PNG";
    V1ChannelMediaMimeType["IMAGE_WEBP"] = "IMAGE_WEBP";
    V1ChannelMediaMimeType["VIDEO_MPEG"] = "VIDEO_MPEG";
    V1ChannelMediaMimeType["VIDEO_MP4"] = "VIDEO_MP4";
    V1ChannelMediaMimeType["VIDEO_3GP"] = "VIDEO_3GP";
    V1ChannelMediaMimeType["AUDIO_AAC"] = "AUDIO_AAC";
    V1ChannelMediaMimeType["AUDIO_MP4"] = "AUDIO_MP4";
    V1ChannelMediaMimeType["AUDIO_MPEG"] = "AUDIO_MPEG";
    V1ChannelMediaMimeType["AUDIO_OGG"] = "AUDIO_OGG";
    V1ChannelMediaMimeType["AUDIO_OPUS"] = "AUDIO_OPUS";
    V1ChannelMediaMimeType["APPLICATION_PDF"] = "APPLICATION_PDF";
    V1ChannelMediaMimeType["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(V1ChannelMediaMimeType = exports.V1ChannelMediaMimeType || (exports.V1ChannelMediaMimeType = {}));
var VersionStatus;
(function (VersionStatus) {
    VersionStatus["NONE_STATUS"] = "NONE_STATUS";
    VersionStatus["DRAFT"] = "DRAFT";
    VersionStatus["SUBMITTED"] = "SUBMITTED";
    VersionStatus["IN_REVIEW"] = "IN_REVIEW";
    VersionStatus["APPROVED"] = "APPROVED";
    VersionStatus["PUBLISHED"] = "PUBLISHED";
    VersionStatus["DECLINED"] = "DECLINED";
    VersionStatus["ARCHIVED"] = "ARCHIVED";
    VersionStatus["HIDDEN"] = "HIDDEN";
    VersionStatus["RELEASED"] = "RELEASED";
})(VersionStatus = exports.VersionStatus || (exports.VersionStatus = {}));
var VerticalDocking;
(function (VerticalDocking) {
    VerticalDocking["NO_VDOCKING"] = "NO_VDOCKING";
    VerticalDocking["TOP_DOCKING"] = "TOP_DOCKING";
    VerticalDocking["VCENTER"] = "VCENTER";
    VerticalDocking["BOTTOM_DOCKING"] = "BOTTOM_DOCKING";
})(VerticalDocking = exports.VerticalDocking || (exports.VerticalDocking = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode["PAGE"] = "PAGE";
    ViewMode["MODAL"] = "MODAL";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
var WidgetHorizontal;
(function (WidgetHorizontal) {
    WidgetHorizontal["NONE_HORIZONTAL"] = "NONE_HORIZONTAL";
    WidgetHorizontal["LEFT"] = "LEFT";
    WidgetHorizontal["CENTER_HORIZONTAL"] = "CENTER_HORIZONTAL";
    WidgetHorizontal["RIGHT"] = "RIGHT";
})(WidgetHorizontal = exports.WidgetHorizontal || (exports.WidgetHorizontal = {}));
var WidgetVertical;
(function (WidgetVertical) {
    WidgetVertical["NONE_VERTICAL"] = "NONE_VERTICAL";
    WidgetVertical["TOP"] = "TOP";
    WidgetVertical["CENTER_VERTICAL"] = "CENTER_VERTICAL";
    WidgetVertical["BOTTOM"] = "BOTTOM";
})(WidgetVertical = exports.WidgetVertical || (exports.WidgetVertical = {}));
var WidgetWidthType;
(function (WidgetWidthType) {
    WidgetWidthType["NONE_TYPE"] = "NONE_TYPE";
    WidgetWidthType["CUSTOM"] = "CUSTOM";
    WidgetWidthType["FULL"] = "FULL";
})(WidgetWidthType = exports.WidgetWidthType || (exports.WidgetWidthType = {}));
var WixCodePublishTaskName;
(function (WixCodePublishTaskName) {
    WixCodePublishTaskName["UNKNOWN"] = "UNKNOWN";
    WixCodePublishTaskName["USER_CODE_BUNDLE"] = "USER_CODE_BUNDLE";
    WixCodePublishTaskName["EXPORTED_FUNCTIONS_ANALYSIS"] = "EXPORTED_FUNCTIONS_ANALYSIS";
    WixCodePublishTaskName["IMPORTED_NAMESPACES_ANALYSIS"] = "IMPORTED_NAMESPACES_ANALYSIS";
    WixCodePublishTaskName["PAGE_DETAILS_ANALYSIS"] = "PAGE_DETAILS_ANALYSIS";
})(WixCodePublishTaskName = exports.WixCodePublishTaskName || (exports.WixCodePublishTaskName = {}));
//# sourceMappingURL=types.js.map